/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.LoginRequest = factory(root.BpmbuildUatDsappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The LoginRequest model module.
   * @module model/LoginRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>LoginRequest</code>.
   * @alias module:model/LoginRequest
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>LoginRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LoginRequest} obj Optional instance to populate.
   * @return {module:model/LoginRequest} The populated <code>LoginRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('authenticateProvider'))
        obj.authenticateProvider = ApiClient.convertToType(data['authenticateProvider'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('facebookId'))
        obj.facebookId = ApiClient.convertToType(data['facebookId'], 'String');
      if (data.hasOwnProperty('firstName'))
        obj.firstName = ApiClient.convertToType(data['firstName'], 'String');
      if (data.hasOwnProperty('languageId'))
        obj.languageId = ApiClient.convertToType(data['languageId'], 'String');
      if (data.hasOwnProperty('pin'))
        obj.pin = ApiClient.convertToType(data['pin'], 'String');
      if (data.hasOwnProperty('roleType'))
        obj.roleType = ApiClient.convertToType(data['roleType'], 'String');
      if (data.hasOwnProperty('surname'))
        obj.surname = ApiClient.convertToType(data['surname'], 'String');
      if (data.hasOwnProperty('twitterId'))
        obj.twitterId = ApiClient.convertToType(data['twitterId'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('userEmail'))
        obj.userEmail = ApiClient.convertToType(data['userEmail'], 'String');
      if (data.hasOwnProperty('userName'))
        obj.userName = ApiClient.convertToType(data['userName'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} authenticateProvider
   */
  exports.prototype.authenticateProvider = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} facebookId
   */
  exports.prototype.facebookId = undefined;

  /**
   * @member {String} firstName
   */
  exports.prototype.firstName = undefined;

  /**
   * @member {String} languageId
   */
  exports.prototype.languageId = undefined;

  /**
   * @member {String} pin
   */
  exports.prototype.pin = undefined;

  /**
   * @member {String} roleType
   */
  exports.prototype.roleType = undefined;

  /**
   * @member {String} surname
   */
  exports.prototype.surname = undefined;

  /**
   * @member {String} twitterId
   */
  exports.prototype.twitterId = undefined;

  /**
   * @member {String} type
   */
  exports.prototype.type = undefined;

  /**
   * @member {String} userEmail
   */
  exports.prototype.userEmail = undefined;

  /**
   * @member {String} userName
   */
  exports.prototype.userName = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/LoginRequest.js